export enum InputFieldType {
  NUMBER = 'number',
  TEL = 'tel',
  EMAIL = 'email',
  PASSWORD = 'password',
  TEXT = 'text',
}

export type TooltipContentParams = Record<string, any>;
export type TooltipContentType = 'text' | 'method';
export interface TooltipContent {
  type?: TooltipContentType;
  text?: string;
  method?: () => JSX.Element;
}

export interface InputField {
  type: InputFieldType;
  label: string;
  name?: string;
  error?: string;
  required?: boolean;
  pattern?: RegExp | null;
  placeholder?: string;
  hasTooltip?: boolean;
  toolTipContent?: TooltipContent;
}

export type InputFields = Array<InputField>;

